export const MODE_TODAY = 'today';
export const MODE_NEXT_WEEK = 'next_week';
export const MODE_NEXT_MONTH = 'next_month';
export const MODE_THIS_YEAR = 'this_year';
export const MODE_PERIOD = 'period';
